export default {
  data() {
    return {
      currentTimestamp: null,
      currentTimestampInterval: null,
      currentTimestampUnix: null
    };
  },

  created() {
    this.calculateCurrentTimestamp();

    this.currentTimestampInterval = setInterval(this.calculateCurrentTimestamp, 1000);
  },

  unmounted() {
    clearInterval(this.currentTimestampInterval);
  },

  methods: {
    calculateCurrentTimestamp() {
      this.currentTimestamp = new Date().toISOString();
      this.currentTimestampUnix = Date.now();
    }
  }
};
